import React from 'react';
import get from 'lodash/get';
import moment from 'moment';
import ListResource from './ListResource.jsx';
import env from '../../../commons/config/env';
import { roads, themes } from '../../../themeReports/components/pages/FormThemeReportsManagement.jsx';

const truncate = (s, n = 80) => {
  if (!s) return '';
  const str = String(s);
  return str.length > n ? `${str.slice(0, n)}...` : str;
};

const ListThemeReports = () => (
  <ListResource
    {...{
      searchable: [
        { value: 'nameZh', label: '隊伍編號' },
        { value: 'nameEn', label: '指導老師' },
        { value: 'partiStudents', label: '參賽學生' },
        {
          value: 'complete',
          label: 'Completed',
          options: [
            { value: true, label: 'Yes' },
            { value: false, label: 'No' },
          ],

        },
        {
          value: 'subjects',
          label: '類別',
          options: Object.entries(get(env, 'subjects', {})).map(([key, val]) => ({
            value: key,
            label: val.zhhk,
          })),
        },
        {
          value: 'road',
          label: '形式',
          options: roads.map((r) => ({ value: r, label: r })),
        },
        {
          value: 'theme',
          label: '主題',
          options: themes.map((t) => ({ value: t, label: t })),
        },
      ],
      api: 'api/themeReports',
      sort: { namezhhk: 1 },
      actions: {
        find: true,
        create: false,
        remove: false,
        fileExport: true,
        jsonExport: true,
      },
      onRowClick: () => {},
      cols: [
        {
          key: 'nameZh',
          children: '隊伍編號',
          sortable: true,
          getter: (v, r) => get(r, 'nameZh', ''),
        },
        {
          key: 'nameEn',
          children: '指導老師',
          sortable: true,
          getter: (v, r) => get(r, 'nameEn', ''),
        },
        {
          key: 'schoolNameZhhk',
          children: '學校名稱',
          sortable: true,
          getter: (v, r) => get(r, 'schoolNameZhhk', ''),
        },
        {
          key: 'partiStudents',
          children: '參賽學生',
        },
        {
          key: 'submittedAt',
          children: '提交日期',
          sortable: true,
          getter: (v) => (!v ? '' : moment(v).format('YYYY/MM/DD')),
        },
        {
          key: 'submittedAt',
          children: '提交時間',
          sortable: false,
          getter: (v) => (!v ? '' : moment(v).format('HH:mm')),
        },

        {
          key: 'subjects',
          children: '類別',
        },
        // ...[1, 2, 3, 4, 5].map((i) => ({
        //   key: `readingMaterial${i}`,
        //   children: `閱讀材料 ${i}`,
        // })),
        {
          key: 'theme',
          children: '主題',
        },
        // {
        //   key: 'tools',
        //   children: '使用工具',
        // },

        // {
        //   key: 'formats',
        //   children: '形式',
        // },
        // {
        //   key: 'links',
        //   children: '參考連結',
        //   getter: (v) => v,
        // },
        {
          key: 'road',
          children: '形式',
        },
        {
          key: 'complete',
          sortable: true,
        },
      ],
    }}
  />
);

export default ListThemeReports;
